import { useEffect } from "react";

const EMBED_SRC = "https://www.instagram.com/embed.js";
const process = () => window.instgrm && window.instgrm.Embeds.process();

export const InstagramEmbed = ({ url, className = "" }) => {
  useEffect(() => {
    const existing = document.querySelector(`script[src="${EMBED_SRC}"]`);
    if (existing) {
      process();
      return;
    }
    const s = document.createElement("script");
    s.src = EMBED_SRC;
    s.async = true;
    s.onload = process;
    document.body.appendChild(s);
  }, [url]);

  return (
    <blockquote
      className={`instagram-media ${className}`}
      data-instgrm-permalink={url}
      data-instgrm-version="14"
      style={{ background: "#FFF", border: 0, margin: "0 auto", maxWidth: "540px", width: "100%" }}
    />
  );
};

export default InstagramEmbed;
